<template>
  <div>
    <div class="entete border-entete">
      <div class="is-paddingless section">
        <div class="level">
          <div class="level-left">
            <div class="columns is-gapless">
              <div class="column">
                <h1 class="title is-size-3">
                  {{ $t('stock.newStock.title', { bon: bon }) }}
                </h1>
                <app-breadcrumb :breadcrumb="breadcrumb" />
              </div>
            </div>
          </div>
          <div class="level-right">
            <div class="is-pulled-right buttons boutonAction">
              <a class="button is-cancel btn-modal-annuler " @click="annuler()">
                {{ $t('editionCommande.actions.revert') }}
              </a>
              <a class="button is-addOrEdit " @click="enregistrerBonStock()">
                {{ $t('general.button.sauvegarder') }}
              </a>
            </div>
          </div>
        </div>
        <error-msg-component :messages="messages"
                             :error="error"
                             :title="'editionClient.problemOccurred'"
                             :withEmplyFields="true"
                             :messagesChampsVide="messagesChampsVide"
                             :champsVide="champsVide"
                             @close="error = $event" />
      </div>
    </div>
    <div class="pdt-20px">
      <div class="card">
        <header class="header-card">
          <p>
            {{ $t('stock.generalTitle.generalInformations') }}
          </p>
        </header>
        <div class="card-content">
          <div class="columns is-multiline">
            <div class="column is-2">
              <b-field :label="dateDeBon" class="obligatoire">
                <b-datepicker show-week-number nearby-selectable-month-days
                              v-model="nouveauStock.dateBon" icon="calendar-today">
                </b-datepicker>
              </b-field>
            </div>
            <div class="column is-3">
              <b-field class="obligatoire" :label="$t('stock.informations.lieuDeStockage')">
                <b-autocomplete
                  v-model="selected"
                  :placeholder="$t('stock.informations.lieuDeStockage')"
                  :data="lieuDeStockage" field="nomCommercial" :loading="isFetching"
                  :open-on-focus="true"
                  @typing="getLieuxStockage"
                  @select="option => nouveauStock.lieuDeStockageId = option ? option.id : null">
                  <template #empty>
                    {{ $t(`general.autocomplete.${!isFetching ? 'noRslt' : 'search'}`) }}
                  </template>
                </b-autocomplete>
              </b-field>
            </div>
            <div class="column is-3">
              <b-field :label="$t('stock.informations.origine')" class="obligatoire">
                <b-select expanded v-model="nouveauStock.origine" :disabled="true">
                  <option :value="null"></option>
                  <option :value="constantes.ORIGINE_TYPE_DIVERS">
                    {{ $t('stock.origineType.bonDivers') }}</option>
                  <option :value="constantes.ORIGINE_TYPE_COMMANDE">
                    {{ $t('stock.origineType.commande') }}</option>
                </b-select>
              </b-field>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="pdt-20px">
      <div class="card">
        <header class="header-card">
          <p>
            {{ $t('stock.generalTitle.mouvementStock') }}
          </p>
        </header>
        <div class="card-content">
          <div class="columns is-multiline">
            <div class="column is-4" v-if="nouveauStock.origine === constantes.ORIGINE_TYPE_DIVERS">
              <b-autocomplete :open-on-focus="true" icon="magnify" :data="autoCompleteData"
                v-model="search" :loading="isFetching" field="libelleAutocomplete"
                @input="getProduit"
                :placeholder="$t('stock.newStock.produit.search')"
                @select="item => selectProduit(item)">
              </b-autocomplete>
            </div>
            <div class="column is-5"
                 v-if="nouveauStock.origine === constantes.ORIGINE_TYPE_DIVERS"></div>
            <div class="column is-6">
              <v-client-table :data="mouvementsStock"
                              :columns="columns"
                              :options="options"
                              ref="tableItems">
                <template #produit="{ row }">
                  <div>{{ row.produit.libelle }}</div>
                </template>
                <template #quantite="{ row }">
                  <div>
                    <b-field>
                      <qd-numberinput v-model="row.quantite"
                        :disabled="nouveauStock.origine === constantes.ORIGINE_TYPE_COMMANDE"
                        min="0"
                        :controls="false"
                        @input="updateQuantity(row)">
                      </qd-numberinput>
                    </b-field>
                  </div>
                </template>
                <template #delete="{ row }">
                  <delete-list-button :query="() => deleteProduit(row.produit.id)"
                    :permissions="stockPerm.supprimer" :title="$t('stock.delete.title')"
                    :subtitle="$t('general.suppression.sousTitre')"
                    :successMessage="$t('stock.delete.suppression')"/>
                </template>
              </v-client-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="pdt-20px">
      <div class="card">
        <header class="header-card">
          <p>
            {{ $t('stock.generalTitle.commentaire') }}
          </p>
        </header>
        <div class="card-content">
          <div class="columns is-multiline">
            <div class="column is-12">
              <b-field :label="$t('stock.generalTitle.commentaire')">
                <b-input v-model="nouveauStock.commentaire"
                         type="textarea"
                         editable="false"
                         rows="4">
                </b-input>
              </b-field>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import debounce from 'lodash/debounce';
import { createNamespacedHelpers } from 'vuex';
import breadcrumb from '@/components/general/breadcrumb';
import {
  BONS_ENTREE,
  BONS_SORTIE,
  BON_ENTREE,
  BON_SORTIE,
  LISTE_BON_ENTREE_ROUTE,
  LISTE_BON_SORTIE_ROUTE,
  DATE_DE_BON_ENTREE,
  DATE_DE_BON_SORTIE,
  ORIGINE_TYPE_COMMANDE,
  ORIGINE_TYPE_DIVERS,
  BON_STOCK_TYPE_ENTREE,
  BON_STOCK_TYPE_SORTIE,
  DETAILS_BON_ENTREE_ROUTE,
  DETAILS_BON_SORTIE_ROUTE,
} from '@/configuration/bonStock/menuStockConf';
import {
  TEXTS,
  SORT_ICON,
} from '@/configuration/clientTableConf';
import { BON_STOCK } from '@/configuration/bonStock/permissionsStockConf';
import { getAll } from '@/api/produit';
import { create, get, update } from '@/api/gabed/bonStock';
import deleteListButton from '@/components/general/button/deleteListButton';
import validationGeneral from '@/services/validation/validation';
import translate from '@/services/bonStock/validation/champsBonStockTranslator';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import { getAll as getAllTiers } from '@/api/tiers';
import messageErreur from '@/services/general/messageErreur';
import { columnsSplice } from '@/services/general/columns';
import formatDate from '@/services/general/formatIsoDate';
import cloneDeep from 'lodash/cloneDeep';
import validationBonStock from '@/services/bonStock/validation/validation';
import { SENS_ACHAT, SENS_VENTE } from '@/configuration/devisConf';

const societe = createNamespacedHelpers('societe');

export default {
  props: {
    isEntree: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      error: false,
      constantes: {
        BON_STOCK,
        ORIGINE_TYPE_COMMANDE,
        ORIGINE_TYPE_DIVERS,
      },
      nouveauStock: {
        dateBon: new Date(),
        lieuDeStockageId: null,
        origine: ORIGINE_TYPE_DIVERS,
        mouvements: [],
        commentaire: null,
        type: BON_STOCK_TYPE_ENTREE,
        ligneCommandeId: null,
      },
      lieuDeStockage: [],
      autoCompleteData: [],
      isFetching: false,
      search: null,
      stockPerm: BON_STOCK,
      messagesChampsVide: [],
      champsVide: [],
      mouvementsStock: [],
      messages: [],
      selected: null,
      reset: false,
    };
  },
  components: {
    appBreadcrumb: breadcrumb,
    deleteListButton,
    errorMsgComponent,
  },
  computed: {
    ...societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    type() {
      return this.isEntree ? this.$t(BONS_ENTREE) : this.$t(BONS_SORTIE);
    },
    breadcrumb() {
      return [
        { title: this.$t('general.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('stock.breadcrumb.liste', { bons: this.type }), route: { name: this.routeName }, isActive: false },
        { title: this.title, route: '', isActive: true },
      ];
    },
    bon() {
      return this.isEntree ? this.$t(BON_ENTREE) : this.$t(BON_SORTIE);
    },
    title() {
      return this.$t('stock.newStock.title', { bon: this.bon });
    },
    routeName() {
      return this.isEntree ? LISTE_BON_ENTREE_ROUTE : LISTE_BON_SORTIE_ROUTE;
    },
    dateDeBon() {
      return this.isEntree ? this.$t(DATE_DE_BON_ENTREE) : this.$t(DATE_DE_BON_SORTIE);
    },
    detailRoute() {
      return this.isEntree ? DETAILS_BON_ENTREE_ROUTE : DETAILS_BON_SORTIE_ROUTE;
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          produit: this.$t('stock.tab.produit'),
          quantite: this.$t('stock.tab.quantite'),
          delete: '',
        },
        filterable: false,
        texts: TEXTS,
        columnsClasses: {
          delete: 'colonneSelected',
          produit: 'vertical-alignment',
        },
        sortable: [],
      };
    },
    columns() {
      const column = ['produit', 'quantite', 'delete'];
      if (this.nouveauStock.origine === this.constantes.ORIGINE_TYPE_COMMANDE) {
        columnsSplice(column, 'delete');
      }
      return column;
    },
  },
  methods: {
    annuler() {
      this.$router.go(-1);
    },
    getLieuxStockage: debounce(async function getLieux(search) {
      try {
        this.isFetching = true;
        this.lieuDeStockage = (await getAllTiers({
          query: {
            auto: search,
            societeId: this.societeActiveId,
            estLieuStockage: true,
          },
        })).data.result.items;
      } catch (e) {
        messageErreur(this.$i18n);
        throw e;
      } finally {
        this.isFetching = false;
      }
    }, 300),
    selectProduit(produitSelect) {
      if (!produitSelect) return;
      this.mouvementsStock.push({
        produitId: produitSelect.id,
        produit: produitSelect,
        quantite: 0,
      });
      this.reset = true;
    },
    updateQuantity(mouvement) {
      const findIndex = this.mouvementsStock.findIndex(
        mvt => mvt.produitId === mouvement.produitId);
      if (findIndex < 0) return;
      this.mouvementsStock.splice(findIndex, 1, mouvement);
    },
    async enregistrerBonStock() {
      this.messagesChampsVide = [];
      const loadingComponent = this.$buefy.loading.open();
      try {
        const stockToSend = cloneDeep(this.nouveauStock);
        if (!this.isEntree) {
          stockToSend.type = BON_STOCK_TYPE_SORTIE;
        }
        stockToSend.mouvements = cloneDeep(this.mouvementsStock);
        stockToSend.mouvements.forEach(
          mvt => { delete mvt.produit; });
        stockToSend.dateBon = formatDate(stockToSend.dateBon);
        let bonStock = null;
        if (this.nouveauStock.id) {
          bonStock = (await update(stockToSend)).data.result;
        } else {
          bonStock = (await create(stockToSend)).data.result;
        }
        this.$router.push({
          name: this.detailRoute, params: { id: bonStock.id },
        });
      } catch (e) {
        if (e.response) {
          this.error = true;
          this.messagesChampsVide = [];
          this.champsVide = [];
          this.messages = [];
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translate);
          validationBonStock(e.response, this.messages);
          loadingComponent.close();
          return;
        }
        messageErreur(this.$i18n);
        throw (e);
      } finally {
        loadingComponent.close();
      }
    },
    deleteProduit(id) {
      this.search = '';
      const mvtIndex = this.mouvementsStock.findIndex(
        mvt => mvt.produitId === id);
      if (mvtIndex < 0) return;
      this.mouvementsStock.splice(mvtIndex, 1);
    },
    getProduit: debounce(async function loadData() {
      if (this.reset) {
        this.search = '';
        this.reset = false;
        return;
      }
      this.isFetching = true;
      this.autoCompleteData = [];
      try {
        if (this.search.length === 0) {
          this.isFetching = false;
          return;
        }
        const produits = (await getAll({
          query: {
            auto: this.search,
            societeId: this.societeActiveId,
            stockable: true,
            sens: this.isEntree ? SENS_VENTE : SENS_ACHAT,
          },
        })).data.result.items;
        produits.forEach((produit) => {
          produit.libelleAutocomplete = produit.libelle + ' - ' + produit.reference;
        });
        this.autoCompleteData = produits.filter(
          p => !this.mouvementsStock.find(mvt => mvt.produitId === p.id),
        );
      } catch (e) {
        messageErreur(this.$i18n);
        throw (e);
      } finally {
        this.isFetching = false;
      }
    }, 500),
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      if (this.$route.params.id) {
        this.nouveauStock = (await get(this.$route.params.id)).data.result;
        this.nouveauStock.dateBon = new Date(this.nouveauStock.dateBon);
        this.lieuDeStockage = [this.nouveauStock.lieuDeStockage];
        this.mouvementsStock = this.nouveauStock?.mouvements ?? [];
        this.selected = this.nouveauStock.lieuDeStockage.nomCommercial;
      }
    } catch (e) {
      messageErreur(this.$i18n);
      throw (e);
    } finally {
      loadingComponent.close();
    }
  },
};
</script>
